module.exports = __webpack_public_path__ + "1318a4278bf6f2cafdf2a82add60eba6.jpg";